export default function isNumeric(value: any) {
  return /^-?[0-9.,]+/.test(value);
}
